export const Roles = {
  anonymous: 'anonymous',
  observer: 'observer',
  operator: 'operator',
  seniorOperator: 'senior-operator',
  driver: 'driver',
  auditor: 'auditor',
  accountant: 'accountant',
  storekeeper: 'storekeeper',
  manager: 'manager',
  seniorManager: 'senior-manager',
  financeManager: 'finance_manager',
};

export const SENIOR_MANAGER_ASSIGNABLE_ROLES = [
  Roles.manager,
  Roles.accountant,
  Roles.financeManager,
] as const;

export const MANAGER_ASSIGNABLE_ROLES = [Roles.operator, Roles.driver, Roles.storekeeper] as const;

export const PROTECTED_ROLES = [Roles.seniorManager] as const;

export const canBanUser = (currentUserRoles: string[], targetUserRoles: string[]): boolean => {
  const isCurrentManager =
    currentUserRoles.includes(Roles.manager) || currentUserRoles.includes(Roles.seniorManager);

  if (!isCurrentManager) {
    return false;
  }

  const isTargetSeniorManager = targetUserRoles.includes(Roles.seniorManager);

  return !isTargetSeniorManager;
};

export const getAssignableRoles = (currentUserRoles: string[]): string[] => {
  const assignable: string[] = [];

  if (currentUserRoles.includes(Roles.seniorManager)) {
    assignable.push(...SENIOR_MANAGER_ASSIGNABLE_ROLES);
  }

  if (currentUserRoles.includes(Roles.manager) || currentUserRoles.includes(Roles.seniorManager)) {
    assignable.push(...MANAGER_ASSIGNABLE_ROLES);
  }

  return [...new Set(assignable)];
};
